module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar'), _vm._v(" "), _c('c-content', [_c('c-panel-container', [_c('c-panel', {
    attrs: {
      "img": _vm.itemObj.orderIcon,
      "title": _vm.itemObj.orderTitle,
      "desc": ("x " + (_vm.itemObj.orderQuantity))
    }
  }, [_c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm._f("currency0")(_vm.itemObj.totalPrice)))])])], 1), _vm._v(" "), _c('c-cell-container', [_c('c-cell', {
    staticClass: "cell-item",
    class: _vm.itemObj.orderStatusType,
    attrs: {
      "title": "订单状态",
      "desc": _vm.itemObj.orderStatus,
      "point": false
    }
  }), _vm._v(" "), _c('c-cell', {
    staticClass: "cell-item",
    attrs: {
      "title": "购买时间",
      "desc": _vm.itemObj.shoppingDate,
      "point": false
    }
  }), _vm._v(" "), _c('c-cell', {
    staticClass: "cell-item",
    attrs: {
      "title": "支付方式",
      "desc": _vm.itemObj.orderPayTypeDesc,
      "point": false
    }
  }), _vm._v(" "), _c('c-cell', {
    staticClass: "cell-item",
    attrs: {
      "title": "订单号",
      "desc": _vm.itemObj.orderNum,
      "point": false
    }
  }), _vm._v(" "), (_vm.itemObj.isRepay) ? [_c('c-button', {
    nativeOn: {
      "click": function($event) {
        _vm.repay($event)
      }
    }
  }, [_vm._v("重新支付")])] : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-309aafe0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/about-me/order-detail/item-detail/index.vue
// module id = 1030
// module chunks = 2